<template>
	<div class="addDeviceManagement" id="add-device">
		<el-card>
			<!-- 返回列表页面 -->
			<div class="jump-btn">
				<el-button type="primary" @click="backToDevice()">{{$t('lang.btn_backDeviceManagement')}}</el-button>
			</div>
			<el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_w6"
				:label-suffix="require('@/config/enum').c_colon">
				<!-- 设备连接地址 -->
				<el-form-item :label="$t('lang.lab_deviceLinkAddress')" prop="url" v-if="this.editid != ''">
					<el-input v-model="form.url" :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_name')"
						:disabled='true' class="inputdis"></el-input>
					<!-- <div class="qrcode" ref="qrCodeUrl1"></div> -->
				</el-form-item>
				<!-- 设备二维码 -->
				<el-form-item label="设备二维码" v-if="this.editid != ''&&this.form.url!=''" style="position:relative">
					<!-- <div class="qrcode" ref="qrCodeUrl" v-if="!ewmurl"></div>
					<el-image v-if="ewmurl" style="width: 440px;" :src="ewmurl" fit="fit"></el-image> -->
					<div class="qrcode" ref="qrCodeUrl"></div>
					<el-button type="primary" @click="showEditEwm()" style="margin-left:20px;position:absolute;bottom:15px;">自定义二维码
					</el-button>
				</el-form-item>
				<!-- 全部小区时，下拉小区列表 -->
				<el-form-item :label="$t('lang.lab_garden')" prop="gardenId">
					<el-select v-model="form.gardenId" class="selGard">
						<el-option key :label="$t('lang.lab_chooseGarden')" value="" v-if="showGarden"></el-option>
						<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 设备名称 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_name')" prop="name">
					<el-input v-model="form.name"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_name')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 主要参数3 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_param3')" prop="param3">
					<el-input v-model="form.param3"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_param3')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 设备编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_deviceNo')" prop="deviceNo">
					<el-input v-model="form.deviceNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_deviceNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 设备分类 -->
				<el-form-item label="设备分类" prop="deviceTypesOf">
					<el-select v-model="form.deviceTypesOf" class="selGard" placeholder="请选择设备分类">
						<el-option v-for="(item,index) in deviceTypesOfList" :key="index" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<!-- 主要参数1 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_param1')" prop="param1">
					<el-input v-model="form.param1"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_param1')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 主要参数2 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_param2')" prop="param2">
					<el-input v-model="form.param2"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_param2')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 数量 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_count')" prop="count">
					<el-input v-model="form.count"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_count')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 单位 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_unit')" prop="unit">
					<el-input v-model="form.unit"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_unit')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 使用安装位置 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_useposition')" prop="usePosition">
					<el-input v-model="form.usePosition"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_useposition')" class="inputdis"
						maxlength="100"></el-input>
				</el-form-item>
				<!-- 使用单位编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_useUnitNo')" prop="useUnitNo">
					<el-input v-model="form.useUnitNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_useUnitNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 设备出厂编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_deviceOutNo')" prop="deviceOutNo">
					<el-input v-model="form.deviceOutNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_deviceOutNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 设备注册代码 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_deviceRegNo')" prop="deviceRegNo">
					<el-input v-model="form.deviceRegNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_deviceRegNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 维保单位 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_keepUnit')" prop="keepUnit">
					<el-input v-model="form.keepUnit"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_keepUnit')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 使用单位代码 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_useUnitCode')" prop="useUnitCode">
					<el-input v-model="form.useUnitCode"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_useUnitCode')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 检验单位 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_testUnit')" prop="testUnit">
					<el-input v-model="form.testUnit"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_testUnit')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 使用登记证编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_useRegInNo')" prop="useRegInNo">
					<el-input v-model="form.useRegInNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_useRegInNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 年检日期 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_yearTestDate')" prop="yearTestDate">
					<el-date-picker class="inputdis" v-model="form.yearTestDate" type="date" value-format="timestamp"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_yearTestDate')">
					</el-date-picker>
				</el-form-item>
				<!-- 下次年检日期 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_nextYearTestDate')" prop="nextYearTestDate">
					<el-date-picker class="inputdis" v-model="form.nextYearTestDate" type="date" value-format="timestamp"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_nextYearTestDate')">
					</el-date-picker>
				</el-form-item>
				<!-- 设备型号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_deviceModel')" prop="deviceModel">
					<el-input v-model="form.deviceModel"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_deviceModel')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 生产厂家 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_madeIn')" prop="madeIn">
					<el-input v-model="form.madeIn"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_madeIn')" class="inputdis"
						maxlength="100"></el-input>
				</el-form-item>
				<!-- 启用日期 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_startDate')" prop="startDate">
					<el-date-picker class="inputdis" v-model="form.startDate" type="date" value-format="timestamp"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_startDate')">
					</el-date-picker>
				</el-form-item>
				<!-- 出厂日期 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_outDate')" prop="outDate">
					<el-date-picker class="inputdis" v-model="form.outDate" type="date" value-format="timestamp"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_outDate')">
					</el-date-picker>
				</el-form-item>
				<!-- 标准编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_standardNo')" prop="standardNo">
					<el-input v-model="form.standardNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_standardNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 产品编号 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_productNo')" prop="productNo">
					<el-input v-model="form.productNo"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_productNo')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 转数 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_turnCount')" prop="turnCount">
					<el-input v-model="form.turnCount"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_turnCount')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 电流 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_current')" prop="current">
					<el-input v-model="form.current"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_current')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 必需汽蚀余量 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_npsh')" prop="npsh">
					<el-input v-model="form.npsh"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_npsh')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 额定电压 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_ratedVoltage')" prop="ratedVoltage">
					<el-input v-model="form.ratedVoltage"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_ratedVoltage')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 控制方式 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_controlMode')" prop="controlMode">
					<el-input v-model="form.controlMode"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_controlMode')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 轿厢尺寸 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_carSize')" prop="carSize">
					<el-input v-model="form.carSize"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_carSize')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 层站 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_landing')" prop="landing">
					<el-input v-model="form.landing"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_landing')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 额定功率 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_ratedOutput')" prop="ratedOutput">
					<el-input v-model="form.ratedOutput"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_ratedOutput')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 载重 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_carrying')" prop="carrying">
					<el-input v-model="form.carrying"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_carrying')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 速度 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_speed')" prop="speed">
					<el-input v-model="form.speed"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_speed')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 功率因数 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_powerFactor')" prop="powerFactor">
					<el-input v-model="form.powerFactor"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_powerFactor')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 扬程 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_lift')" prop="lift">
					<el-input v-model="form.lift"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_lift')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 流量 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_flow')" prop="flow">
					<el-input v-model="form.flow"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_flow')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 压力 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_pressure')" prop="pressure">
					<el-input v-model="form.pressure"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_pressure')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 容积 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_cubage')" prop="cubage">
					<el-input v-model="form.cubage"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_cubage')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 重量 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_weight')" prop="weight">
					<el-input v-model="form.weight"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_weight')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 位置 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_position')" prop="position">
					<el-input v-model="form.position"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_position')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 用途 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_purpose')" prop="purpose">
					<el-input v-model="form.purpose"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_purpose')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 范围 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_scope')" prop="scope">
					<el-input v-model="form.scope"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_scope')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 备注1 -->
				<el-form-item :label="$t('lang.lbl_deviceManagement_note1')" prop="note1">
					<el-input v-model="form.note1"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_note1')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 备注2 -->
				<el-form-item label="电表倍率" prop="note2">
					<el-input v-model="form.note2"
						placeholder="请输入电表倍率" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 备注3 -->
				<el-form-item label="设备类型" prop="note3">
					<el-select v-model="form.note3" placeholder="请选择设备类型" class="select">
						<el-option label="请选择" value=''></el-option>
						<el-option label="水表" value='水表'></el-option>
						<el-option label="电表" value='电表'></el-option>
					</el-select>
				</el-form-item>				
				<!-- 上传图片 -->
				<el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="imgUri" ref="imgUri">
					<upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='fileListTemp' :clears='clears'
						@outputFile="getFile" @removeFile='removeFile'></upload-morefile>
				</el-form-item>
				<!-- 二维码显示 -->
				<!-- <el-form-item :label="$t('lang.lbl_isShowQr')" prop="qrRadio">
					<el-radio v-model="qrRadio" label="1">{{$t('lang.yes')}}</el-radio>
					<el-radio v-model="qrRadio" label="0">{{$t('lang.no')}}</el-radio>
				</el-form-item> -->
				<div v-if="qrRadio=='1'">
					<!-- 设备类型 -->
					<el-form-item :label="$t('lang.lab_deviceType')" prop="deviceType">
						<el-select v-model="form.deviceType" :placeholder="$t('lang.plh.sel') + $t('lang.lab_deviceType')">
							<el-option v-for="item in deviceTypeList" :key="item.Id" :label="item.Name" :value="item.Id">
							</el-option>
						</el-select>
						<!-- <el-cascader :options="deviceType" :props="typeProps" clearable v-model="form.deviceType">
								<template slot-scope="{ node, data }" :value="data.Id">
									<span>{{ data.Name }}</span>
									<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
								</template>
							</el-cascader> -->
					</el-form-item>
					<!-- 登录机关 -->
					<el-form-item :label="$t('lang.lab_registrar')" prop="registrar">
						<el-input v-model="form.registrar" :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_registrar')"
							class="inputdis" maxlength="50"></el-input>
					</el-form-item>
					<!-- 下次检验时间 -->
					<el-form-item :label="$t('lang.lab_nextInspectionTime')" prop="nextInspectionTime">
						<el-date-picker class="inputdis" v-model="form.nextInspectionTime" type="date" value-format="timestamp"
							:placeholder="$t('lang.plh.sel') + $t('lang.lab_nextInspectionTime')">
						</el-date-picker>
					</el-form-item>
					<!-- 下次计划保养时间 -->
					<el-form-item class="nextPMTime" :label="$t('lang.lab_nextPlannedMaintenanceTime')"
						prop="nextPlannedMaintenanceTime">
						<el-date-picker class="inputdis" v-model="form.nextPlannedMaintenanceTime" type="date"
							value-format="timestamp" :placeholder="$t('lang.plh.sel') + $t('lang.lab_nextPlannedMaintenanceTime')">
						</el-date-picker>
					</el-form-item>
				</div>

				<el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="save('form')" class="detailbtn" :disabled="isDisabled">{{$t('lang.btn_save')}}
				</el-button>
			</el-form>
			<el-dialog title="自定义设备二维码" v-if="this.editid" :visible.sync="dialogVisible" @closed="delQrcode" width="60%">
				<div class="canvasDialog">
					<div class="canvasBox" :class="showColor" id="capture" v-if="ewmStyle==1">
						<h2>设备信息卡</h2>
						<div class="infoBox">
							<div class="infoText">
								<div>所在项目：{{form.garden.name}}</div>
								<div>设备名称：{{form.name}}</div>
							</div>
							<div ref="qrCodeUrl1"></div>
						</div>
					</div>
					<div class="canvasBox1" id="capture" v-if="ewmStyle==2">
						<h2>设备信息卡</h2>
						<div class="infoBox1">
							<div class="infoText1">
								<div>所在项目：{{form.garden.name}}</div>
								<div>设备名称：{{form.name}}</div>
							</div>
							<div ref="qrCodeUrl1"></div>
						</div>
					</div>
					<div class="canvasSet">
						<h3>标签背景</h3>
						<div class="bgBox">
							<p @click="changeColor(item)" v-for="(item,index) in this.colorList" :key="index" :class="item">
								<span v-if="showColor==item">✔</span>
							</p>
						</div>
						<!-- <el-button class="saveBtn" type="primary" @click="downloadEwm(1)">下载</el-button>
						<el-button class="saveBtn1" type="primary" @click="downloadEwm(2)">保存</el-button> -->
					</div>

				</div>
				<div class="cardStyle">
					<h3>卡片样式</h3>
					<div class="cardType">
						<div @click="changeStyle(1)" class="mr10">
							<el-image style="width: 200px;"
								src="https://oss.kmyhwy.cn/2025/03/19/a50e9678-da7f-47af-a61c-e2b8019fc4a8.png" fit="fit"></el-image>
							<span v-if="ewmStyle==1">✔</span>
						</div>
						<div @click="changeStyle(2)" class="mr10">
							<el-image style="width: 200px;"
								src="https://oss.kmyhwy.cn/2025/03/19/5ea3f052-d6c0-45b6-beb5-85f8a625b075.png" fit="fit"></el-image>
							<span v-if="ewmStyle==2">✔</span>
						</div>
					</div>

				</div>
				<div style="height:50px;"></div>
				<el-button class="saveBtn" type="primary" @click="downloadEwm()">下载</el-button>
				<!-- <el-button class="saveBtn1" type="primary" @click="downloadEwm(2)">保存</el-button> -->
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
	/**
	 *@ClassName:addDeviceManagement
	 *@Description:设备管理
	 *@author:李斌
	 *@Copyright:格众科技
	 *@date:2020-03-31
	 */
	import QRCode from 'qrcodejs2'
	import html2canvas from 'html2canvas'
	import uploadmoreFile from '../../../components/upload_morefile.vue'
	import {
		mapGetters
	} from 'vuex'

	export default {
		data() {
			return {
				clears: false, // 清空按钮
				accept: '.jpg, .jpeg, .png',
				isDisabled: true, // 保存的可点击
				saveData: '', // 存储JSON数据
				editid: '', // 接收编辑页面的参数     
				types: [], // 下拉列表
				showGarden: true, // 判断小区显示
				fileList: [], // 上传图片列表
				fileListTemp: [], // 上传图片列表

				qrRadio: '0', // 存储二维码单选值
				qrRadioFix: '0', // 监听二维码单选
				qrIsShow: false, // 是否显示二维码信息
				deviceTypeList: [], // 存储设备数组
				deviceQRObj: {}, // 存储二维码对象
				/* typeProps: {
					value: 'Id',
					label: 'Name',
					children: 'children',
					checkStrictly: true
				}, */

				form: {
					gardenId: '', // 小区下拉
					url: '', // 设备连接地址
					name: '', // 设备名称
					deviceNo: '', // 设备编号
					param1: '', // 主要参数1
					param2: '', // 主要参数2
					param3: '', // 主要参数3
					count: '', // 数量
					unit: '', // 单位
					usePosition: '', // 使用安装位置
					useUnitNo: '', // 使用单位编号
					deviceOutNo: '', // 设备出厂编号
					deviceRegNo: '', //  设备注册代码
					keepUnit: '', // 维保单位
					useUnitCode: '', // 使用单位代码
					testUnit: '', // 检验单位
					useRegInNo: '', // 使用登记证编号
					yearTestDate: '', // 年检日期
					nextYearTestDate: '', // 下次年检日期
					deviceModel: '', // 设备型号
					madeIn: '', // 生产厂家
					startDate: '', // 启用日期
					outDate: '', // 出厂日期
					standardNo: '', // 标准编号
					productNo: '', // 产品编号
					turnCount: '', // 转数
					current: '', // 电流
					npsh: '', // 必需汽蚀余量
					ratedVoltage: '', // 额定电压
					controlMode: '', // 控制方式
					carSize: '', // 轿厢尺寸
					landing: '', // 层站
					ratedOutput: '', // 额定功率
					carrying: '', // 载重
					speed: '', // 速度
					powerFactor: '', // 功率因数
					lift: '', // 扬程
					flow: '', // 流量
					pressure: '', // 压力
					cubage: '', // 容积
					weight: '', // 重量
					position: '', // 位置
					purpose: '', // 用途
					scope: '', // 范围
					note1: '', // 备注1
					note2: '', // 备注2
					note3: '', // 备注3
					imgUri: '', // 图片 

					deviceType: '', // 设备类型
					registrar: '', // 登记机关
					nextInspectionTime: '', // 下次检验时间
					nextPlannedMaintenanceTime: '', // 下次计划保养时间
					deviceTypesOf: '', // 设备分类（新）

				},
				rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lbl_deviceManagement_name'),
						trigger: 'blur'
					}],
					gardenId: [{
						required: true,
						message: this.$i18n.t('lang.lab_chooseGarden'),
						trigger: 'change'
					}],
					deviceType: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_deviceType'),
						trigger: 'blur'
					}],
					registrar: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lab_registrar'),
						trigger: 'blur'
					}],
					nextInspectionTime: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_nextInspectionTime'),
						trigger: 'blur'
					}],
					nextPlannedMaintenanceTime: [{
						required: true,
						message: this.$i18n.t('lang.plh.sel') + this.$i18n.t('lang.lab_nextPlannedMaintenanceTime'),
						trigger: 'blur'
					}],
					deviceTypesOf: [{
						required: true,
						message: '请选择设备分类',
						trigger: 'change'
					}],
				},
				dialogVisible: false,
				colorList: ['c-218aff', 'c-ff6f01', 'c-55ba05', 'c-186dcc', 'c-cc4214', 'c-878f95'],
				showColor: 'c-218aff',
				ewmurl: '',
				ewmStyle: 1,
				deviceTypesOfList: [
					{
						name: '工程',
					},
					{
						name: '客服',
					},
					{
						name: '秩序',
					},
					{
						name: '保洁',
					},
					{
						name: '绿化',
					},
				], // 设备分类列表
			}
		},
		components: {
			'upload-morefile': uploadmoreFile
		},
		computed: {
			...mapGetters({
				gardenId: 'gardenId'
			})
		},
		// #8449 add
		destroyed() {
			this.deviceManagementForm = {
				form: JSON.stringify(this.form),
				saveData: this.saveData,
				fileList: JSON.stringify(this.fileList), // 红方观点
				fileListTemp: this.fileListTemp
			}
			window.localStorage.setItem('deviceManagementForm', JSON.stringify(this.deviceManagementForm))
		},
		created() {
			this.getDeviceType()
			if (this.$store.getters.permission === '*') {
				this.form.gardenId = this.$store.getters.gardenId === 0 ? '' : this.$store.getters.gardenId
				if (this.form.gardenId === '') {
					this.showGarden = true
				} else {
					this.showGarden = false
				}
				this.gardens()
			} else {
				this.showGarden = false
				this.form.gardenId = this.$store.getters.gardenId
				this.types = this.$store.getters.userGardenList
			}
			// #8449 add
			if (window.localStorage.getItem('deviceManagementForm') && this.$route.query.id == '') {
				let deviceManagementForm = JSON.parse(window.localStorage.getItem('deviceManagementForm'))
				this.form = JSON.parse(deviceManagementForm.form)
				this.saveData = deviceManagementForm.saveData
				this.fileList = JSON.parse(deviceManagementForm.fileList)
				this.fileListTemp = deviceManagementForm.fileListTemp
			} else {
				// 接收编辑页面参数
				if (this.$route.query.id) {
					this.editid = this.$route.query.id
					this.deviceById()
				}
			}
		},
		mounted() {
			window.addEventListener('scroll', this.handleScroll, true)
		},
		watch: {
			form: {
				handler(newVal, oldVal) {
					// ruleForm数据变化时 会调用此方法
					let tempRule = ''
					/* if (newVal != undefined) {
						tempRule = JSON.stringify(newVal)
					} else {
						tempRule = newVal
					} */
					tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			},
			qrRadio(val) {
				let qrShow = this.qrRadioFix
				if (val == qrShow) {
					this.isDisabled = true
				} else {
					this.isDisabled = false
				}
			}
		},
		methods: {
			// 改变二维码图片背景图颜色
			changeColor(item) {
				this.showColor = item
			},
			// 展示编辑二维码弹窗
			showEditEwm() {
				let that = this
				that.dialogVisible = true
				setTimeout(() => {
					let qrcode1 = new QRCode(that.$refs.qrCodeUrl1, {
						text: that.form.url, // 需要转换为二维码的内容
						width: 100,
						height: 100,
						colorDark: '#000000',
						colorLight: '#ffffff',
						correctLevel: QRCode.CorrectLevel.H
					})
					console.log(qrcode1)
				}, 100)
			},
			// 删除二维码
			delQrcode() {
				this.$refs.qrCodeUrl1.innerHTML = ''
			},
			// 生成设备二维码
			creatQrCode() {
				let that = this
				let qrcode = new QRCode(that.$refs.qrCodeUrl, {
					text: that.form.url, // 需要转换为二维码的内容
					width: 100,
					height: 100,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
				console.log(qrcode)
			},
			// 获取组件值
			getFile(e) {
				this.fileList.push({
					name: '',
					url: e
				})
				this.isDisabled = false
			},
			// 移除图片
			removeFile(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i] === e || (this.fileList[i].url && this.fileList[i].url === e)) {

					} else {
						list1.push(this.fileList[i])
					}
				}
				this.fileList = list1
				this.fileListTemp = JSON.parse(JSON.stringify(list1))
			},
			// 返回列表页
			backToDevice() {
				this.$router.push({
					name: 'deviceManagementList'
				})
			},
			gardens() {
				let loading = this.$loading()
				this.$get(`/gardens`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.types = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			getDeviceType() {
				let loading = this.$loading()
				this.$get(`/DeviceType/selectAllList`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.deviceTypeList = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			deviceById() {
				let loading = this.$loading()
				this.$get(`/deviceById/` + this.editid).then(res => {
						console.log(res)
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res.device
							if (this.form.gardenId === 0) {
								this.form.gardenId = ''
							}
							this.fileList = []
							if (res.device.imgUri && res.device.imgUri.length > 0) {
								var resUrl = res.device.imgUri.split(',')
								for (let i = 0; i < resUrl.length; i++) {
									this.fileList.push({
										name: '',
										url: resUrl[i]
									})
								}
							}
							this.deviceQr()
							// 生成设备二维码
							this.$nextTick(function () {
								this.creatQrCode()
							})
							this.fileListTemp = JSON.parse(JSON.stringify(this.fileList))
							this.saveData = JSON.stringify(this.form)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			deviceQr() {
				let loading = this.$loading()
				this.$get(`/selectByDeviceId/?deviceId=` + this.editid).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							if (res.deviceQR != null) {
								this.qrRadio = '1'
								this.qrRadioFix = '1'
								this.$set(this.form, 'deviceType', res.deviceQR.type)
								this.$set(this.form, 'registrar', res.deviceQR.registrar)
								this.$set(this.form, 'nextInspectionTime', res.deviceQR.nextInspectionTime)
								this.$set(this.form, 'nextPlannedMaintenanceTime', res.deviceQR.nextPlannedMaintenanceTime)

								this.fileListTemp = JSON.parse(JSON.stringify(this.fileList))
								this.saveData = JSON.stringify(this.form)
							} else {
								this.fileListTemp = JSON.parse(JSON.stringify(this.fileList))
								this.saveData = JSON.stringify(this.form)
							}
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						let filesList = []
						if (this.editid === '') {
							// 上传图片
							if (this.fileList.length > 0) {
								for (let i = 0; i < this.fileList.length; i++) {
									if (this.fileList[i] && this.fileList[i].url) {
										filesList.push(this.fileList[i].url)
									} else {
										filesList.push(this.fileList[i])
									}
								}
							}
							let loading = this.$loading()
							let params = {
								gardenId: this.form.gardenId,
								name: this.form.name,
								deviceNo: this.form.deviceNo,
								param1: this.form.param1,
								param2: this.form.param2,
								param3: this.form.param3,
								count: this.form.count,
								unit: this.form.unit,
								usePosition: this.form.usePosition,
								useUnitNo: this.form.useUnitNo,
								deviceOutNo: this.form.deviceOutNo,
								deviceRegNo: this.form.deviceRegNo,
								keepUnit: this.form.keepUnit,
								useUnitCode: this.form.useUnitCode,
								testUnit: this.form.testUnit,
								useRegInNo: this.form.useRegInNo,
								deviceModel: this.form.deviceModel,
								madeIn: this.form.madeIn,
								standardNo: this.form.standardNo,
								productNo: this.form.productNo,
								turnCount: this.form.turnCount,
								current: this.form.current,
								npsh: this.form.npsh,
								ratedVoltage: this.form.ratedVoltage,
								controlMode: this.form.controlMode,
								carSize: this.form.carSize,
								landing: this.form.landing,
								ratedOutput: this.form.ratedOutput,
								carrying: this.form.carrying,
								speed: this.form.speed,
								powerFactor: this.form.powerFactor,
								lift: this.form.lift,
								flow: this.form.flow,
								pressure: this.form.pressure,
								cubage: this.form.cubage,
								weight: this.form.weight,
								position: this.form.position,
								purpose: this.form.purpose,
								scope: this.form.scope,
								yearTest: this.form.yearTestDate,
								nextYearTest: this.form.nextYearTestDate,
								start: this.form.startDate,
								out: this.form.outDate,
								ImgUri: filesList.toString(),
								note1: this.form.note1,
								note2: this.form.note2,
								note3: this.form.note3,
								deviceTypesOf: this.form.deviceTypesOf,
							}

							this.$post(`/device`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										var deviceId = res.id
										if (this.qrRadio == '1') {
											let qrParams = {
												deviceId: deviceId,
												type: this.form.deviceType,
												registrar: this.form.registrar,
												nextInspectionTime: this.form.nextInspectionTime,
												nextPlannedMaintenanceTime: this.form.nextPlannedMaintenanceTime
											}
											this.$postJson(`/DeviceQRAdd`, qrParams).then(
												res => {
													loading.close()
													if (res && res.errCode === 0) {
														this.$message.success(this.$i18n.t('lang.lab_save_success'))
														this.backToDevice()
													}
												},
												error => {
													loading.close()
													this.$message.error(error)
												}
											)
										} else {
											this.$message.success(this.$i18n.t('lang.lab_save_success'))
											this.backToDevice()
										}
										var index = this.$keepAlive.indexOf('/manage/main.deviceList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						} else {
							let loading = this.$loading()
							// 上传图片
							if (this.fileList.length > 0) {
								for (let i = 0; i < this.fileList.length; i++) {
									if (this.fileList[i] && this.fileList[i].url) {
										filesList.push(this.fileList[i].url)
									} else {
										filesList.push(this.fileList[i])
									}
								}
							}
							/* 查询deviceqr表是否有数据并判断当前qrRadio的状态 */
							this.$get(`/selectByDeviceId/?deviceId=` + this.editid).then(res => {
									loading.close()
									if (res && res.errCode === 0) {
										let qrParams = {
											deviceId: this.editid,
											type: this.form.deviceType,
											registrar: this.form.registrar,
											nextInspectionTime: this.form.nextInspectionTime,
											nextPlannedMaintenanceTime: this.form.nextPlannedMaintenanceTime
										}
										if (res.deviceQR != null && this.qrRadio == '1') {
											this.$postJson(`/DeviceQREdit`, qrParams).then(
												res => {
													loading.close()
												},
												error => {
													loading.close()
													this.$message.error(error)
												}
											)
										} else if (res.deviceQR != null && this.qrRadio == '0') {
											this.$postJson(`/DeviceQRDel`, {
												deviceId: this.editid
											}).then(
												res => {
													loading.close()
												},
												error => {
													loading.close()
													this.$message.error(error)
												}
											)
										} else if (res.deviceQR == null && this.qrRadio == '1') {
											this.$postJson(`/DeviceQRAdd`, qrParams).then(
												res => {
													loading.close()
												},
												error => {
													loading.close()
													this.$message.error(error)
												}
											)
										}
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								})
							let params = {
								gardenId: this.form.gardenId,
								name: this.form.name,
								deviceNo: this.form.deviceNo,
								param1: this.form.param1,
								param2: this.form.param2,
								param3: this.form.param3,
								count: this.form.count,
								unit: this.form.unit,
								usePosition: this.form.usePosition,
								useUnitNo: this.form.useUnitNo,
								deviceOutNo: this.form.deviceOutNo,
								deviceRegNo: this.form.deviceRegNo,
								keepUnit: this.form.keepUnit,
								useUnitCode: this.form.useUnitCode,
								testUnit: this.form.testUnit,
								useRegInNo: this.form.useRegInNo,
								deviceModel: this.form.deviceModel,
								madeIn: this.form.madeIn,
								standardNo: this.form.standardNo,
								productNo: this.form.productNo,
								turnCount: this.form.turnCount,
								current: this.form.current,
								npsh: this.form.npsh,
								ratedVoltage: this.form.ratedVoltage,
								controlMode: this.form.controlMode,
								carSize: this.form.carSize,
								landing: this.form.landing,
								ratedOutput: this.form.ratedOutput,
								carrying: this.form.carrying,
								speed: this.form.speed,
								powerFactor: this.form.powerFactor,
								lift: this.form.lift,
								flow: this.form.flow,
								pressure: this.form.pressure,
								cubage: this.form.cubage,
								weight: this.form.weight,
								position: this.form.position,
								purpose: this.form.purpose,
								scope: this.form.scope,
								yearTest: this.form.yearTestDate,
								nextYearTest: this.form.nextYearTestDate,
								start: this.form.startDate,
								out: this.form.outDate,
								ImgUri: filesList.toString(),
								note1: this.form.note1,
								note2: this.form.note2,
								note3: this.form.note3,
								deviceTypesOf: this.form.deviceTypesOf,
							}
							this.$patch(`/device/${this.editid}`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										this.backToDevice()
									}
									var index = this.$keepAlive.indexOf('/manage/main.deviceList')
									if (index > -1) {
										this.$keepAlive.splice(index, 1)
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						}
					}
				})
			},
			handleScroll() {
				let elDate = document.getElementsByClassName('el-picker-panel')
				if (elDate.length != 0) {
					for (let i = 0; i < elDate.length; i++) {
						const element = elDate[i]
						element.style.display = 'none'
					}
				}
			},
			rest(form) {
				this.clears = true
				this.$refs.form.clearValidate()
				this.form.url = ''
				this.form.gardenId = ''
				this.form.name = ''
				this.form.deviceNo = ''
				this.form.param1 = ''
				this.form.param2 = ''
				this.form.param3 = ''
				this.form.count = ''
				this.form.unit = ''
				this.form.usePosition = ''
				this.form.useUnitNo = ''
				this.form.deviceOutNo = ''
				this.form.deviceRegNo = ''
				this.form.keepUnit = ''
				this.form.useUnitCode = ''
				this.form.testUnit = ''
				this.form.useRegInNo = ''
				this.form.yearTestDate = ''
				this.form.nextYearTestDate = ''
				this.form.deviceModel = ''
				this.form.madeIn = ''
				this.form.startDate = ''
				this.form.outDate = ''
				this.form.standardNo = ''
				this.form.productNo = ''
				this.form.turnCount = ''
				this.form.current = ''
				this.form.npsh = ''
				this.form.ratedVoltage = ''
				this.form.controlMode = ''
				this.form.carSize = ''
				this.form.landing = ''
				this.form.ratedOutput = ''
				this.form.carrying = ''
				this.form.speed = ''
				this.form.powerFactor = ''
				this.form.lift = ''
				this.form.flow = ''
				this.form.pressure = ''
				this.form.cubage = ''
				this.form.weight = ''
				this.form.position = ''
				this.form.purpose = ''
				this.form.scope = ''
				this.form.note1 = ''
				this.form.note2 = ''
				this.form.note3 = ''
				this.form.imgUri = ''
				this.fileList = []
				this.form.registrar = ''
				this.form.nextInspectionTime = ''
				this.form.nextPlannedMaintenanceTime = ''
				this.form.deviceTypesOf = ''
			},
			// 改变二维码图片样式
			changeStyle(index) {
				this.ewmStyle = index
			},
			// 下载二维码图片
			downloadEwm() {
				let that = this
				var shareContent = document.querySelector('#capture')
				var width = shareContent.offsetWidth
				var height = shareContent.offsetHeight
				var canvas = document.createElement('canvas')
				var scale = 1
				canvas.width = width * scale
				canvas.height = height * scale
				canvas.getContext('2d').scale(scale, scale)
				var opts = {
					scale: scale,
					canvas: canvas,
					logging: true,
					width: width,
					height: height,
					useCORS: true
				}
				html2canvas(shareContent, opts).then(function (canvas) {
					const imgUrl = canvas.toDataURL('jpg')
					that.ewmurl = imgUrl
					// ie浏览器单独处理
					if (window.navigator.msSaveOrOpenBlob) {
						var bstr = atob(imgUrl.split(',')[1])
						var n = bstr.length
						var u8arr = new Uint8Array(n)
						while (n--) {
							u8arr[n] = bstr.charCodeAt(n)
						}
						var blob = new Blob([u8arr])
						window.navigator.msSaveOrOpenBlob(blob, '设备信息卡' + '.' + 'png')
					} else {
						// 这里就按照chrome等新版浏览器来处理
						const a = document.createElement('a')
						a.href = imgUrl
						a.setAttribute('download', '设备信息卡')
						a.click()
					}
				})
				that.dialogVisible = false
				that.delQrcode()
			},
		}
	}
</script>

<style lang='scss'>
	.addDeviceManagement {
		.inputdis {
			width: 50%;
		}

		.selGard {
			width: 50%;
		}

		.nextPMTime label {
			width: 150px !important;
		}

		.qrcode {
			display: inline-block;

			img {
				width: 132px;
				height: 132px;
				border: 1px solid #999;
				background-color: #fff; //设置白色背景色
				padding: 6px; // 利用padding的特性，挤出白边
				box-sizing: border-box;
			}
		}

		.canvasDialog {
			display: flex;
		}

		.canvasBox {
			// display: flex;
			min-width: 400px;
			height: 200px;
			padding: 20px;
			background-color: #218aff;
			color: #fff;
		}

		.canvasBox1 {
			// display: flex;
			min-width: 440px;
			height: 240px;
			// padding: 20px;
			background-color: #fff;
			color: #000;
			border: 1px solid #000;
			box-sizing: border-box;
		}

		.canvasBox1 h2 {
			padding: 10px 20px;
			text-align: center;
			border-bottom: 1px solid #000;
		}

		.infoBox {
			display: flex;
			padding: 20px;
			margin-top: 20px;
			border-radius: 10px;
			font-size: 16px;
			font-weight: bold;
			color: #000;
			background-color: #fff;
		}

		.infoBox1 {
			display: flex;
			padding: 40px 20px 20px 0;
			font-size: 16px;
			font-weight: bold;
			color: #000;
			background-color: #fff;
		}

		.infoText {
			flex: 1;
			margin-right: 10px;
		}

		.infoText1 {
			flex: 1;
			margin-right: 10px;
			border: 1px solid #000;
			border-left: none;
		}

		.infoText div {
			margin-bottom: 10px;
		}

		.infoText1 div {
			padding: 5px 0 5px 5px;
			border-bottom: 1px solid #000;
		}

		.canvasSet {
			margin-left: 50px;
			position: relative;
		}

		.bgBox {
			display: flex;
			max-height: 190px;
			margin-top: 30px;
			flex-wrap: wrap;
			justify-content: flex-start;
			overflow: auto;
		}

		.bgBox p {
			width: 60px;
			height: 60px;
			margin: 10px;
			border-radius: 10px;
			background-color: #218aff;
			position: relative;
		}

		.bgBox span {
			color: #fff;
			font-weight: bold;
			position: absolute;
			bottom: 5px;
			right: 5px;
		}

		.saveBtn {
			position: absolute;
			bottom: 10px;
			right: 20px;
		}

		.saveBtn1 {
			position: absolute;
			bottom: 10px;
			right: 110px;
		}

		.cardStyle {
			margin-top: 20px;
		}

		.cardType {
			margin-top: 20px;
			margin-right: 10px;
			display: flex;
		}

		.mr10 {
			margin-right: 10px;
			position: relative;
		}

		.cardType span {
			position: absolute;
			right: 1px;
			bottom: 5px;
			background-color: #218aff;
			padding: 10px 10px 10px 15px;
			border-radius: 50px 0 0 0;
			color: #fff;
		}

		.c-218aff {
			background-color: #218aff !important;
		}

		.c-ff6f01 {
			background-color: #ff6f01 !important;
		}

		.c-55ba05 {
			background-color: #55ba05 !important;
		}

		.c-186dcc {
			background-color: #186dcc !important;
		}

		.c-cc4214 {
			background-color: #cc4214 !important;
		}

		.c-878f95 {
			background-color: #878f95 !important;
		}
	}
</style>